import { mapDataToModelInstance, MappingConfig } from 'helpers';

export function mapRelatedPersonToDataModel<TData, T>(dataModel: TData, type: new () => T): TData {
    const modelMapping: MappingConfig<T> = {
        relatedPerson: type,
    };

    return mapDataToModelInstance(dataModel, 'relatedPerson', modelMapping) as TData;
}